import { createTheme } from '@mui/material/styles';

/**
 * Palette mirrors the U.S. Census Bureau's net-domestic-migration figure:
 * a muted blue for positive net migration, a salmon red for negative.
 */
export const MIGRATION_COLORS = {
  positive: '#3B82B8',
  negative: '#E4694E',
  accent: '#1C6EA4',
} as const;

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: MIGRATION_COLORS.accent },
    secondary: { main: MIGRATION_COLORS.negative },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a2027',
      secondary: '#5a6672',
    },
  },
  typography: {
    fontFamily: [
      '"Inter"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontSize: '1.5rem', fontWeight: 700, letterSpacing: '-0.01em' },
    h2: { fontSize: '1.125rem', fontWeight: 600 },
    caption: { fontSize: '0.75rem', lineHeight: 1.4 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});
